{
  "navigation": {
    "overview": "لمحة عامة",
    "diesel": "المحروقات",
    "petrol": "البنزين",
    "revolvingBalances": "الأرصدة المدورة",
    "purchases": "المشتريات",
    "sales": "المبيعات",
    "debtMovements": "مبيعات الذمم",
    "payments": "المدفوعات",
    "receipts": "المقبوضات",
    "debtors": "عملاء الذمم",
    "closes": "حركات الإغلاق",
    "sendMessage": "إرسال رسالة",
    "trash": "سلة المحذوفات",
    "settings": "الإعدادات",
    "settingsPrices": "الأسعار والإعدادات",
    "settingsCategories": "التصنيفات",
    "settingsYears": "إدارة السنوات",
    "settingsUsers": "المستخدمين",
    "settingsGroups": "المجموعات",
    "pdaCustomers": "عملاء المشتريات",
    "settingsNationalities": "الجنسيات",
    "pendingTransactions": "الحركات المعلقة"
  },
  "sidebar": {
    "title": "القائمة الجانبية",
    "description": "قائمة التنقل",
    "toggleHint": "تبديل التنقل (Ctrl/Cmd+B)",
    "toggle": "تبديل القائمة الجانبية"
  },
  "user": {
    "notifications": "الإشعارات"
  },
  "documentTitle": "المحروقات - لوحة التحكم",
  "nav": {
    "changeBranch": "تغيير الفرع",
    "systems": "الأنظمة"
  }
}
